<template>
  <div class="container-fluid py-4">
    <div class="card" :class="{ 'fullscreen-mode': isFullscreen }">
      <div class="card-header d-flex justify-content-between align-items-center">
        <h4 class="mb-0">{{ title }}</h4>
        <button class="btn btn-sm" @click="toggleFullscreen" :title="isFullscreen ? 'Exit Fullscreen' : 'Enter Fullscreen'">
          <i :class="isFullscreen ? 'fas fa-compress' : 'fas fa-expand'"></i>
        </button>
      </div>
      <div class="card-body matrix-container">
        <table class="table" v-if="heatmap && heatmap.length > 0">
          <thead>
            <tr>
              <th class="name-cell"></th>
              <th class="" v-for="person in people" :key="person">
                <div class="skill-header">
                  {{person}}
                </div>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="sop in heatmap" :class="sop.isSpace ? 'space-heatmap-row' : 'sop-heatmap-row'">
              <td class="name-cell">
                <div style="display: flex; justify-content: space-between">
                  <div style="display: flex; flex-direction: column; ">
                    <h5 v-if="!sop.isSpace">{{sop.name}}</h5>
                    <div v-else class="space-breadcrumb">
                      <h2>
                        <span v-for="(crumb, index) in sop.breadcrumb" :key="index">
                          {{crumb}}<span v-if="index < sop.breadcrumb.length - 1" class="breadcrumb-separator">/</span>
                        </span>
                      </h2>
                    </div>
                    <p style="max-width: 500px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;">{{sop.description}}</p>
                  </div>
                  <button class="open-btn" @click="GoToOnboarding(sop.id, sop.isSpace)" title="Go to onboaring">
                    <i class="fas fa-external-link"></i>
                  </button>
                </div>
              </td>
              <td v-for="person in people" :key="person">
                <div v-if="!sop.isSpace" :class="'skill-level ' + getSkillLevel(getPersonStats(sop.data, person))">
                  <textarea v-if="false">{{JSON.stringify(getPersonStats(sop.data, person))}}</textarea>
                </div>
                <div v-else class="skill-level level-1" style="visibility: hidden;"></div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'SkillMatrix',
    data() {
      return {
        isFullscreen: false
      }
    },
    // The list of all available skills
    props: {
      people: {
        type: Array,
        required: true,
        default: () => []
      },
      sops: {
        type: Array,
        required: true,
        default: () => []
      },
      heatmap: {
        type: Array,
        required: true,
        default: () => []
      },
      // Value for v-model (assigned skills)
      value: {
        type: Array,
        default: () => []
      },
      // Component title
      title: {
        type: String,
        default: 'Skills Management'
      },
      // Tab labels
      availableTabLabel: {
        type: String,
        default: 'Available'
      },
      assignedTabLabel: {
        type: String,
        default: 'Assigned'
      }
    },
    methods: {
      getPersonStats(data, person) {        
        // Try to find an exact match first
        let stats = data.find(point => point.x === person);
        
        // If no exact match, try case-insensitive
        if (!stats) {
          stats = data.find(point => point.x.toLowerCase() === person.toLowerCase());
        }
        
        // If still no match, try trimming whitespace
        if (!stats) {
          stats = data.find(point => point.x.trim().toLowerCase() === person.trim().toLowerCase());
        }
        
        // Log the result in a clear format
        if (!stats) {
          return { x: person, y: 0 };
        }
        
        return stats;
      },
      getSkillLevel(stats) {
        if (!stats || !stats.y) return 'level-0';
        const level = Math.round(stats.y);
        return `level-${level}`;
      },
      GoToOnboarding(id, isSpace) {
        if (isSpace) {
          window.open("/pages/space/" + id.replace('s-', '')); 
        } else {
          window.open("/pages/pdf-view?oid=" + id.replace('o-', '')); 
        }
      },
      toggleFullscreen() {
        this.isFullscreen = !this.isFullscreen;
        if (this.isFullscreen) {
          document.documentElement.requestFullscreen().catch(e => {
            console.error('Error attempting to enable fullscreen:', e);
          });
        } else {
          if (document.fullscreenElement) {
            document.exitFullscreen();
          }
        }
      }
    }
  }
</script>

<style>
  .matrix-container {
    max-height: 80vh;
    overflow: scroll;
    position: relative;
  }

  .open-btn {
    padding: 6px;
    border-radius: 4px;
    cursor: pointer;
    background-color:transparent;
    color: #666;
    border: 0px;
    transition: all 0.2s;
    width: 32px;
    height: 32px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .open-btn:hover {
    background-color: #f3f4f6;
    color: #000;
  }

  .open-btn.active {
    background-color: #e5e7eb;
    color: #000;
  }

  .space-heatmap-row{
      border:1px solid red;
  }
  /* Remove default table borders */
  .table {
    margin-bottom: 0;
    border-collapse: separate;
    border-spacing: 0;
  }

    /* Reset borders */
    .table td, .table th {
      border: none;
    }

    /* Add borders back with specific styling */
    .table td, .table th {
      border-right: 1px solid #dee2e6;
      border-bottom: 1px solid #dee2e6;
    }

  .skill-header {
    writing-mode: vertical-rl;
    transform: rotate(180deg);
    white-space: nowrap;
    padding: 15px 0;
    min-height: 120px;
    font-size: 0.9rem;
  }

  .avatar {
    width: 32px;
    height: 32px;
    border-radius: 50%;
    background-color: #e9ecef;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 10px;
    font-size: 0.8rem;
  }

  .skill-level {
    width: 24px;
    height: 24px;
    border-radius: 4px;
    margin: auto;
    border:1px solid #efefef;
  }

  .level-1 {
    background-color: rgb(var(--vs-warning));
  }

  .level-2 {
    background-color: rgb(var(--vs-warning));
  }

  .level-3 {
    background-color: rgb(var(--vs-warning));
  }

  .level-4 {
    background-color: rgb(var(--vs-warning));
  }

  .level-5 {
    background-color: rgb(var(--vs-success));
  }

  /* Fixed column styling */
  .name-cell {
    position: sticky;
    left: 0;
    background-color: white;
    z-index: 2;
    min-width: 180px;
  }

  /* Fixed header styling */
  thead th {
    position: sticky;
    top: 0;
    background-color: #f8f9fa;
    z-index: 1;
  }

    /* Corner cell styling */
    thead th.name-cell {
      z-index: 3;
      background-color: #f8f9fa;
      min-width:300px;
    }

  .name-text {
    font-size: 0.9rem;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  td {
    padding: 0.4rem !important;
    background-color: white;
  }

  tr.sop-heatmap-row .name-cell {
    padding-left: 20px !important;
  }

  tr.space-heatmap-row .name-cell {
    padding-left: 10px !important;
  }

    tr.space-heatmap-row .name-cell h2 {
        font-weight:900;
    }
    /* Shadow effects */
    .name-cell {
      box-shadow: 3px 0 4px -2px rgba(0,0,0,0.1);
    }

  thead th {
    box-shadow: 0 3px 4px -2px rgba(0,0,0,0.1);
  }

    thead th.name-cell {
      box-shadow: 3px 3px 4px -2px rgba(0,0,0,0.1);
    }

  /* Card styling */
  .card {
    border: 1px solid #dee2e6;
  }

  .card-body {
    padding: 0;
  }

  @media (max-width: 768px) {
    .name-cell {
      position: relative;
    }
  }

  .space-breadcrumb {
    font-size: 1.1rem;
    color: var(--vs-primary);
    display: flex;
    align-items: center;
    flex-wrap: wrap;
  }

  .breadcrumb-separator {
    margin: 0 5px;
    color: #666;
  }

  .fullscreen-mode {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    z-index: 999999;
    margin: 0;
    border-radius: 0;
    background-color: white;
    display: flex;
    flex-direction: column;
  }

  .fullscreen-mode .card {
    flex: 1;
    display: flex;
    flex-direction: column;
    margin: 0;
  }

  .fullscreen-mode .card-body {
    flex: 1;
    overflow: hidden;
  }

  .fullscreen-mode .matrix-container {
    height: calc(100vh - 60px);
    overflow: scroll;
  }

  .card-header {
    background-color: #f8f9fa;
    border-bottom: 1px solid #dee2e6;
    padding: 0.75rem 1.25rem;
  }

  .card-header button {
    background: transparent;
    border: none;
    color: #666;
    padding: 0.25rem 0.5rem;
    border-radius: 4px;
    transition: all 0.2s;
  }

  .card-header button:hover {
    background-color: #e9ecef;
    color: #000;
  }
</style>
